import { render, staticRenderFns } from "./ExpandedItemWrapper.vue?vue&type=template&id=3fa27b9c"
import script from "./ExpandedItemWrapper.vue?vue&type=script&lang=js"
export * from "./ExpandedItemWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports